import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsObjectSchemaRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object-schema',
	path: '/jira/servicedesk/assets/object-schema/:objectSchemaId',
};
